import React from "react";

export const About = (props) => {
  const features = [];
  if (props.data && props.data.Why && props.data.Why2) {
    const allReasons = [...props.data.Why, ...props.data.Why2];
    
    if (allReasons[0]) features.push({ 
      title: "Expertise & Quality", 
      icon: "fa fa-lightbulb-o", 
      description: allReasons[0] 
    });
    if (allReasons[1]) features.push({ 
      title: "Dedicated Support", 
      icon: "fa fa-users", 
      description: allReasons[1]
    });
    if (allReasons[2]) features.push({ 
      title: "Innovative Solutions", 
      icon: "fa fa-cogs", 
      description: allReasons[2] 
    });
  }

  return (
    <div id="about">
      <div className="container">
        <div className="about-header text-center">
          <p className="subtitle">What We Do</p>
          <h1>About Us</h1> 
        </div>
        
        <div className="row about-main-content">
          <div className="col-xs-12 col-md-6">
            <div className="about-image-container">
              <img src="img/about.png" className="img-responsive" alt="About Us" />
            </div>
          </div>
          <div className="col-xs-12 col-md-6 about-right-content">
            <div className="about-text">
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
            </div>
            
            <div className="why-choose-us-section">
              <div className="row card-row">
                {features.map((feature, i) => (
                  <div key={i} className="col-xs-12 col-sm-6 col-md-4">
                    <div className="feature-card">
                      <div className="card-icon-container">
                        <i className={feature.icon}></i>
                      </div>
                      <h3>{feature.title}</h3>
                      <p>{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* END MODIFIED SECTION */}
        </div>
      </div>
    </div>
  );
};